import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IRegisterModalExecutorProps } from './IRegisterModalExecutorProps';
import { RegisterModalExecutorModal } from './RegisterModalExecutorModal';

export const RegisterModalExecutor = createDocModalExecutor<IRegisterModalExecutorProps>({
    modal: RegisterModalExecutorModal,
    defaultModalSize: 'max',
    emptyElement: <div />,
    mapProps: ({ objId, action, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        saveButtonText: action.options?.saveButtonText ?? 'Сохранить',
        modalSize,
        openInNewTab: action.options?.openInNewTab ?? action.options?.newTab ?? false,
        completeHandler,
    }),
});
